const COUNTRIES_WITHOUT_CITY_NAME_IN_HEADING = ["US", "GB", "AU", "CA", "IE"];
const getRegionHeading = (regionObject: any, withoutMarkup: boolean, lang = "") => {
  let regionHeading = "Student Housing";
  if (regionObject && regionObject.name) {
    let regionName = "";
    if (regionName.length === 0 && regionObject.meta && regionObject.meta.region_name) {
      regionName = regionObject.meta.region_name;
    }
    if (lang === "zh") {
      regionName = regionObject.name || regionName;
    }

    if (regionName.length === 0) {
      const regionNames = [];
      regionNames.push(regionObject.name);
      const countryShortName = regionObject?.location?.country?.short_name;
      const shouldHideCity = COUNTRIES_WITHOUT_CITY_NAME_IN_HEADING.includes(countryShortName);
      if (
        regionObject.region_type === "establishment" &&
        regionObject.parent_name &&
        !shouldHideCity
      ) {
        regionNames.push(regionObject.parent_name);
      }
      regionName = regionNames.join(", ");
    }
    if (regionName.length > 0) {
      if (
        regionObject.meta &&
        regionObject.meta.heading &&
        regionObject.meta.heading.includes("region_name")
      ) {
        regionHeading = `<b>${
          lang === "zh" ? regionName : regionObject.meta.region_name || regionName
        }</b>`;
      } else {
        regionHeading = regionName;
      }
      if (withoutMarkup) {
        regionHeading = regionHeading.replace(/<\/?b>/gim, "");
      } // Replaces all <b></b> tags
    }
  }
  return regionHeading;
};

const headingNameToken = (regionObject: any, lang = "") => {
  if (lang === "zh") {
    return regionObject?.name || regionObject?.meta?.region_name || "";
  }
  return regionObject?.meta?.region_name || regionObject?.name || "";
};

/**
 * The CMS abbreviation for a university region (e.g. "IOE"), trimmed, or "" when it must not be
 * used: not a university (establishment) region, a whitelabel site, or no usable abbreviation.
 * Shared by the search heading and the search property cards so the two always agree.
 */
export const getRegionAbbreviation = (
  regionObject: any,
  { isWhitelabel = false }: { isWhitelabel?: boolean } = {},
): string => {
  if (isWhitelabel || regionObject?.region_type !== "establishment") {
    return "";
  }
  return typeof regionObject?.abbreviation === "string" ? regionObject.abbreviation.trim() : "";
};

/**
 * Abbreviation for the search property cards: only when the user selected this university with the
 * University filter (`appliedUniversity` = `searchPageData.appliedUniversityFilter`). A direct visit
 * to a university search page (including every SSR render) keeps the full name, as today.
 */
export const getUniversityFilterAbbreviation = (
  regionObject: any,
  {
    isWhitelabel = false,
    appliedUniversity = null,
  }: { isWhitelabel?: boolean; appliedUniversity?: string | null } = {},
): string => {
  if (!appliedUniversity || appliedUniversity !== regionObject?.canonical_name) {
    return "";
  }
  return getRegionAbbreviation(regionObject, { isWhitelabel });
};

export const getSearchPageHeadingName = (
  regionObject: any,
  { isWhitelabel = false, lang = "" }: { isWhitelabel?: boolean; lang?: string } = {},
) => {
  const currentHeading = getRegionHeading(regionObject, true, lang);
  const abbreviation = getRegionAbbreviation(regionObject, { isWhitelabel });
  if (!abbreviation) {
    return currentHeading;
  }
  const token = headingNameToken(regionObject, lang);
  if (token && currentHeading.startsWith(token)) {
    return `${abbreviation}${currentHeading.slice(token.length)}`;
  }
  return currentHeading;
};

export default getRegionHeading;
